import { render } from "./NavBar.vue?vue&type=template&id=0b950fae&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=0b950fae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b950fae"]])

export default __exports__